import TinyMceConfig from './tinymce-config';

import EmailsTab from '../../advanced-settings/components/tabs/emails';
import PublicFormTab from '../../advanced-settings/components/tabs/public-form';
import SchedulingTab from '../../advanced-settings/components/tabs/scheduling';
import PaymentTab from '../../advanced-settings/components/tabs/payment'

const Defaults = {
	ADDRESS_TITLE :'<strong>Address</strong>' ,
	LABEL_STREET: 'Street Address',
	LABEL_CITY: 'City',
	LABEL_STATE: 'State',
	LABEL_ZIP: 'Zip/Postal',
	HINT_STREET: '',
	HINT_CITY: '',
	HINT_STATE: '',
	US_STATES: ['Alabama', 'Alaska', 'American Samoa', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Federated States of Micronesia', 'Florida', 'Georgia', 'Guam', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Marshall Islands', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Northern Mariana Islands', 'Ohio', 'Oklahoma', 'Oregon', 'Palau', 'Pennsylvania', 'Puerto Rico', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virgin Islands', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'],
	MX_STATES:['Aguascalientes','Baja California','Baja California Sur','Campeche','CDMX','Coahuila de Zaragoza','Colima','Chiapas','Chihuahua','Durango','Guanajuato','Guerrero','Hidalgo','Jalisco','México','Michoacán de Ocampo','Morelos','Nayarit','Nuevo Leon','Oaxaca','Puebla','Querétaro','Quintana Roo', 'San Luis Potosí', 'Sinaloa', 'Sonora', 'Tabasco', 'Tamaulipas', 'Tlaxcala', 'Veracruz', 'Yucatán', 'Zacatecas'],
	EL_SALVADOR:['Ahuachapán','Cabañas', 'Chalatenango', 'Cuscatlán','La Libertad','La Paz','La Unión','Morazán','San Miguel','San Salvador','San Vicente', 'Santa Ana', 'Sonsonate', 'Usulután'],
	CONTACT_TITLE: '<strong>Contact Information</strong>',
	LABEL_FIRST_NAME:'First Name',
	LABEL_MIDDLE_NAME: 'Middle Name',
	LABEL_LAST_NAME: 'Last Name',
	LABEL_EMAIL1: 'Email 1',
	LABEL_EMAIL2: 'Email 2',
	LABEL_MOBILE_PHONE: 'Mobile Phone',
	LABEL_HOME_PHONE: 'Home Phone',
	LABEL_WORK_PHONE: 'Work Phone',
	NEW_FORM_ID: 'new',
	NEW_FORM_TITLE: 'New Form',
	TEMPLATE_FORM: 'template',
	PLACEHOLDER: 'Add placeholder text here',
	INITIAL_TEXT_BOX_MESSAGE: 'Please complete the form below. Required fields marked with an asterisk *',
	ACTIVE_FORM_DESIGNATION: {
		state: 'Open',
		action: 'open'
	},
	INACTIVE_FORM_DESIGNATION: {
		state: 'Closed',
		action: 'close'
	},
	INITIAL_TEXT_BOX_UNIQUE_ID: 'initial_text_box',
	SAVE_BUTTON_STATE: {
		default: 'default',
		success: 'success',
		failure: 'failure',
		disabled: 'disabled'
	},
	SESSION_STORAGE_KEYS: {
		copyFormData: 'edlioFormBuilderCopyFormData',
		formData: 'edlioFormBuilderFormData',
		formId: 'edlioFormBuilderFormId',
		notification: 'edlioFormBuilderNotificationData',
		selectedSettingsTab: 'edlioFormBuilderSelectedSettingsTab'
	},
	SUBMIT_BUTTON_LABEL: 'Submit',
	RESET_BUTTON_LABEL: 'Reset',
	TINYMCE_CONFIG: TinyMceConfig,
	CONFIRMATION_MESSAGE: 'Thank you. Your response has been recorded.',
	SUBMISSION_RESPONSE_SIGNATURE_CONFIRMATION_MESSAGE: '<p>Thank you. We\'ve received and recorded your completed form with signature.</p><p>A copy of the signed form will be sent to the confirmation email address you provided.</p>',
	SUBMISSION_EMAIL_CONFIRMATION_MESSAGE: '<p>Thank you. We\'ve received and recorded your completed form with signature.</p>',
	FORM_CLOSED_MESSAGE: 'This form is closed.',
	PRE_OPEN_MESSAGE: 'This form is not open yet. Please come back later.',
	ADVANCED_SETTINGS_TABS: [
		{
			label: 'Emails',
			component: EmailsTab
		},
		{
			label: 'Behavior',
			component: PublicFormTab
		},
		{
			label: 'Schedule',
			component: SchedulingTab
		}
	],
	PAYMENT_TAB: {
        label: 'Payment',
        component: PaymentTab
    },
	PAYMENT_TYPE: 'paymentType',
	NO_ACCOUNT: 'None'
};

export default Defaults;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/defaults.js